import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import ChuvaLayout from 'components/Relatorios/Decomp/ChuvaLayout';
import { selectUserIsAdmin } from 'redux/reducers/authReducer';
import useDecompSecaoParams from 'hooks/Relatorios/Decomp/useDecompSecaoParams';
import { useGetDecompChuvaPrevistaQuery } from 'services/api/products/relatorios';

export default function ChuvaPrevista() {
  const userIsAdmin = useSelector(selectUserIsAdmin);
  const params = useDecompSecaoParams();

  const { data, isLoading } = useGetDecompChuvaPrevistaQuery(params);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center p-3">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (!data) {
    return null;
  }

  return <ChuvaLayout data={data} canEdit={userIsAdmin} />;
}
